import { r as registerInstance, h, F as Fragment } from './index-e3eeb4ec.js';
import { S as STATUS, g as getFormattedTime, E as EVENTS, H as HIDE_CONTROLS_TIMEOUT_DURATION, K as KEYBOARD_KEY_CODES } from './index-fd930a73.js';
import { L as Locale } from './index-6afae4e4.js';
const indexCss$2 = ".phoenix-player .phoenix-ad-ui .phx-ad-ui-overlay{position:absolute;top:0;left:0;width:100%;box-sizing:border-box;padding:0 4px;height:24px;line-height:24px;z-index:1;font-size:12px;color:#FFF;background-color:rgba(0, 0, 0, 0.5)}.phoenix-player .phoenix-ad-ui .phx-ad-ui-overlay.hidden{display:none}";
const AdUiOverlayStyle0 = indexCss$2;

// persist adInfo even if web component disconnects/connects
const adInfoRef = (() => {
  let adInfo = null;
  return {
    getAdInfo: () => adInfo,
    setAdInfo: _adInfo => {
      adInfo = _adInfo;
    },
    clear: () => {
      adInfo = null;
    }
  };
})();
const AdUIOverlay = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.playerStatus = null;
    this.isAdShowing = false;
    this.isClientSideAdvertising = false;
    this.adInfo = null;
    this.adCurrentTime = null;
    this.locale = Locale();
    this.onObserverUpdate = state => {
      var _a;
      if (state.status.to === ((_a = this.playerStatus) === null || _a === void 0 ? void 0 : _a.to)) return;
      switch (state.status.to) {
        case STATUS.ADVERTISING:
        case STATUS.ADVERTISING_PAUSED:
          this.isAdShowing = true;
          this.isClientSideAdvertising = state.isClientSideAdvertising;
          break;
        default:
          this.isAdShowing = false;
      }
      this.playerStatus = state.status;
    };
    this.onAdStarted = adStartedPayload => {
      if (!this.isClientSideAdvertising) return;
      adInfoRef.setAdInfo(adStartedPayload);
      this.adInfo = adStartedPayload;
    };
    this.onAdRemainingTimeUpdate = adTimePayload => {
      this.adCurrentTime = adTimePayload;
    };
    this.onAdError = () => {
      this.isAdShowing = false;
    };
    this.renderAdCurrentTime = () => {
      if (this.adCurrentTime === null || this.adCurrentTime < 0) return;
      return getFormattedTime(this.adCurrentTime);
    };
    this.renderPlaybackText = () => {
      const playbackText = this.isClientSideAdvertising ? this.locale.adInProgress : this.locale.advertisement;
      return h("span", {
        class: "playback-text"
      }, playbackText);
    };
    this.renderAdPositionText = () => {
      if (!this.isClientSideAdvertising || !this.renderAdCurrentTime() || !this.adInfo) return;
      const adText = `${this.locale.ad} ${this.adInfo.position} ${this.locale.of} ${this.adInfo.totalAds}: (${this.renderAdCurrentTime()}) `;
      return h("span", {
        class: "ad-position-text"
      }, adText);
    };
  }
  connectedCallback() {
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
    this.publicAPI.on(EVENTS.AD_STARTED, this.onAdStarted);
    this.publicAPI.on(EVENTS.AD_ERRORED, this.onAdError);
    this.publicAPI.on(EVENTS.AD_REMAINING_TIME_UPDATED, this.onAdRemainingTimeUpdate);
    this.adInfo = adInfoRef.getAdInfo();
  }
  disconnectedCallback() {
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
    this.publicAPI.off(EVENTS.AD_STARTED, this.onAdStarted);
    this.publicAPI.off(EVENTS.AD_ERRORED, this.onAdError);
    this.publicAPI.off(EVENTS.AD_REMAINING_TIME_UPDATED, this.onAdRemainingTimeUpdate);
  }
  render() {
    const hideClass = this.isAdShowing ? "" : " hidden";
    return h("div", {
      key: '6dfad04241d8b3743b4ce637875ac286767c7f60',
      class: `phx-ad-ui-overlay${hideClass}`
    }, this.renderAdPositionText(), this.renderPlaybackText());
  }
};
AdUIOverlay.style = AdUiOverlayStyle0;
const indexCss$1 = ".phoenix-player .phx-audio-ui{width:100%;height:100%;background-color:#FFFFFF}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata{display:flex;flex-wrap:wrap}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls{flex:0 0 auto;margin:20px}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-skip-back-btn,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-skip-forward-btn,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-play-btn,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-stop-btn,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-pause-btn{cursor:pointer;border:none;vertical-align:middle;padding:0;background:transparent}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-skip-back-btn:focus,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-skip-forward-btn:focus,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-play-btn:focus,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-stop-btn:focus,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-pause-btn:focus{outline-style:dotted;outline-width:1px;outline-color:#000000}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls.advertising .phx-skip-forward-btn,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls.advertising .phx-skip-back-btn{pointer-events:none}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls.advertising .phx-skip-forward-btn>svg,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls.advertising .phx-skip-back-btn>svg{opacity:0.5}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-skip-back-btn{margin-right:25px}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-skip-forward-btn{margin-left:25px}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-pause-btn>svg,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-stop-btn>svg,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-play-btn>svg{width:60px}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-pause-btn:hover polygon,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-stop-btn:hover polygon,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-play-btn:hover polygon{fill:#e60505}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-stop-btn.media-loading{pointer-events:none}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .primary-controls .phx-stop-btn.media-loading>svg{opacity:0.5}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata{display:flex;flex-basis:0;flex-grow:999;align-items:center}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-thumbnail-wrapper{box-shadow:0px 0px 5px 1px #cbcbcb;height:84.375px;flex:0 0 auto;margin-left:20px}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-thumbnail-wrapper img{width:auto;height:84.375px;object-fit:contain;object-position:center}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-metadata #media-metadata-audio{box-sizing:border-box;padding:0 20px}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-metadata #media-metadata-audio .phoenix-showname,.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-metadata #media-metadata-audio .phoenix-title{padding:0;margin:0}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-metadata #media-metadata-audio .phoenix-showname{font-size:0.8rem;font-weight:bold}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-metadata #media-metadata-audio .phoenix-title{font-size:0.85rem;line-height:1.188rem;max-height:calc(1.188rem * 2);overflow:hidden}.phoenix-player .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-metadata #media-metadata-audio.advertising .phoenix-showname{text-transform:uppercase}.phoenix-player .phx-audio-ui .audio-ui-inner button label{display:block;position:absolute;bottom:calc(-0.6875rem + -6px);padding:6px;border-radius:4px;background:#263238;font-size:0.6875rem;font-weight:bold;white-space:nowrap;transform:translateY(0px);opacity:0;pointer-events:none;line-height:1rem}.phoenix-player .phx-audio-ui .audio-ui-inner button:hover label,.phoenix-player .phx-audio-ui .audio-ui-inner button:focus label{animation:tooltipAnimation 4s;z-index:1;color:white}@keyframes tooltipAnimation{0%{opacity:0;transform:translateY(-40px)}5%{opacity:1;transform:translateY(-70px)}95%{opacity:1;transform:translateY(-70px)}100%{opacity:0;transform:translateY(-40px)}}.phoenix-player .phx-audio-ui .audio-ui-inner .secondary-controls{display:flex;margin:0 20px;position:relative;width:calc(100% - 40px)}.phoenix-player .phx-audio-ui .audio-ui-inner .secondary-controls .audio-seekbar-wrapper{flex:1 0 100px;padding:5px 0}.phoenix-player .phx-audio-ui .audio-ui-inner .secondary-controls .time-metadata{padding:8px 20px;line-height:normal}.phoenix-player .phx-audio-ui .audio-ui-inner .secondary-controls .time-metadata span{color:#000;text-shadow:none;opacity:1;font-size:0.8rem}.phoenix-player .phx-audio-ui .audio-ui-inner .secondary-controls .time-metadata .phx-duration-metadata::before{content:\"/\";margin:0 4px}.phoenix-player .phx-audio-ui .audio-ui-inner .secondary-controls .volume-controls-container .phx-volume-controls{display:flex}.phoenix-player .phx-audio-ui .audio-ui-inner .secondary-controls .volume-controls-container .phx-muted-btn{cursor:pointer;background:transparent;border:none;width:24px;height:24px;box-sizing:content-box;position:relative;padding:5px 0}.phoenix-player .phx-audio-ui .audio-ui-inner .secondary-controls .volume-controls-container .phx-muted-btn.audio label{bottom:calc(-0.6875rem - 29px);right:0}.phoenix-player .phx-audio-ui .audio-ui-inner .secondary-controls .volume-controls-container .phx-volume-slider.audio{width:100%;line-height:26px}.phoenix-player .phx-audio-ui .audio-ui-inner .phx-volume-slider.audio label{bottom:calc(-0.6875rem - 19px)}.phoenix-player.phx-small .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-metadata #media-metadata-audio,.phoenix-player.phx-extra-small .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-metadata #media-metadata-audio{padding:5px 20px 0 20px}.phoenix-player.phx-small .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-thumbnail-wrapper,.phoenix-player.phx-extra-small .phx-audio-ui .audio-ui-inner .primary-controls-and-metadata .thumbnail-metadata .audio-ui-thumbnail-wrapper{display:none}";
const AudioUiStyle0 = indexCss$1;
const DEFAULT_THUMBNAIL = "https://www.cbc.ca/a/images/default_thumbnail.jpg";
const AudioUI = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.showName = "";
    this.chapterThumbnail = "";
    this.isClientSideAdvertising = false;
    this.locale = Locale();
    this.setMediaThumbnail = () => {
      var _a, _b, _c;
      this.mediaThumbnail = encodeURI((_c = (_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.thumbnail) !== null && _c !== void 0 ? _c : DEFAULT_THUMBNAIL);
    };
    this.onObserverUpdate = state => {
      this.isClientSideAdvertising = state.isClientSideAdvertising;
    };
    this.onChapterStart = payload => {
      var _a, _b;
      this.showName = (payload === null || payload === void 0 ? void 0 : payload.show) || ((_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.showName);
      this.chapterThumbnail = encodeURI(payload === null || payload === void 0 ? void 0 : payload.thumbnail) || DEFAULT_THUMBNAIL;
    };
  }
  componentWillLoad() {
    var _a, _b;
    this.setMediaThumbnail();
    if (!this.showName) {
      this.showName = (_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.showName;
    }
  }
  connectedCallback() {
    this.publicAPI.on(EVENTS.CHAPTER_START, this.onChapterStart);
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
  }
  disconnectedCallback() {
    this.publicAPI.off(EVENTS.CHAPTER_START, this.onChapterStart);
    this.publicAPI.mediaStateObserver.unsubscribe(this.onObserverUpdate);
  }
  WatchpublicApiChange() {
    this.setMediaThumbnail();
  }
  render() {
    var _a, _b;
    if (((_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.format) !== "audio") return null;
    const {
      title
    } = this.publicAPI.mediaData;
    const thumbnail = this.chapterThumbnail || this.mediaThumbnail;
    let showName = this.showName;
    let advertisingClass = "";
    if (this.isClientSideAdvertising) {
      showName = this.locale.advertisement;
      advertisingClass = " advertising";
    }
    return h("div", {
      class: "phx-audio-ui",
      "aria-label": "audio player"
    }, h("div", {
      class: "audio-ui-inner"
    }, h("div", {
      class: "primary-controls-and-metadata"
    }, h("div", {
      class: `primary-controls${advertisingClass}`
    }, h("skip-back-btn", {
      publicAPI: this.publicAPI
    }), h("play-pause-stop-btn", {
      publicAPI: this.publicAPI
    }), h("skip-forward-btn", {
      publicAPI: this.publicAPI
    })), h("div", {
      class: "thumbnail-metadata"
    }, h("div", {
      class: "audio-ui-thumbnail-wrapper"
    }, h("img", {
      src: thumbnail,
      alt: ""
    })), h("div", {
      class: "audio-ui-metadata"
    }, h("div", {
      id: "media-metadata-audio",
      class: advertisingClass,
      title: title
    }, h("p", {
      class: "phoenix-showname"
    }, showName), h("p", {
      class: "phoenix-title"
    }, title))))), h("div", {
      class: "secondary-controls"
    }, h("div", {
      class: "audio-seekbar-wrapper"
    }, h("seek-bar", {
      publicAPI: this.publicAPI
    })), h("div", {
      class: "time-metadata"
    }, this.publicAPI.mediaData.isLive ? h("span", null, "Live") : h(Fragment, null, h("currenttime-metadata", {
      publicAPI: this.publicAPI
    }), h("duration-metadata", {
      publicAPI: this.publicAPI
    }))), h("div", {
      class: "volume-controls-container"
    }, h("volume-controls", {
      publicAPI: this.publicAPI
    })))), h("error-overlay", {
      publicAPI: this.publicAPI
    }));
  }
  static get watchers() {
    return {
      "publicAPI": ["WatchpublicApiChange"]
    };
  }
};
AudioUI.style = AudioUiStyle0;
const FullscreenManager = containerNode => {
  const setFullScreen = isEnable => {
    if (!canFullscreen) return;
    if (isEnable && !isFullscreen) {
      requestFullscreen();
    } else if (!isEnable && isFullscreen) {
      exitFullscreen();
    }
    element.focus();
  };
  const updateFullscreen = fullscreenElement => {
    isFullscreen = !!fullscreenElement;
  };
  const updateFullscreenDefault = () => {
    updateFullscreen(fullscreenDocument.fullscreenElement);
  };
  const updateFullscreenWebkit = () => {
    updateFullscreen(fullscreenDocument.webkitFullscreenElement);
    isFullscreen = !!fullscreenDocument.webkitFullscreenElement;
    adjustStylesForWebkit(!isFullscreen);
  };
  const updateEnterFullscreenWebkitiOS = () => {
    updateFullscreen(true);
  };
  const updateExitFullscreenWebkitiOS = () => {
    updateFullscreen(false);
  };
  const updateFullscreenMoz = () => {
    updateFullscreen(fullscreenDocument.mozFullScreenElement);
  };
  const updateFullscreenMs = () => {
    updateFullscreen(fullscreenDocument.msFullscreenElement);
  };
  const updateFullscreeniOS = () => {
    if (!canFullscreen && playbackElement.webkitSupportsFullscreen) {
      canFullscreen = true;
      requestFullscreen = () => playbackElement.webkitEnterFullscreen();
      exitFullscreen = () => playbackElement.webkitExitFullscreen();
      playbackElement.addEventListener("webkitbeginfullscreen", updateEnterFullscreenWebkitiOS);
      playbackElement.addEventListener("webkitendfullscreen", updateExitFullscreenWebkitiOS);
    }
  };
  const init = () => {
    if (!element) return;
    const _playbackElement = element.querySelector("[data-name='phoenix-playback-element']");
    if (!_playbackElement) return;
    playbackElement = _playbackElement;
    if (element["requestFullscreen"]) {
      fullscreenDocument.addEventListener("fullscreenchange", updateFullscreenDefault);
    } else if (element["webkitRequestFullscreen"]) {
      fullscreenDocument.addEventListener("webkitfullscreenchange", updateFullscreenWebkit);
    } else if (element["mozRequestFullScreen"]) {
      fullscreenDocument.addEventListener("mozfullscreenchange", updateFullscreenMoz);
    } else if (element["msRequestFullscreen"]) {
      fullscreenDocument.addEventListener("msfullscreenchange", updateFullscreenMs);
    }
    setupiOSFullscreen();
  };
  const destroy = () => {
    fullscreenDocument.removeEventListener("fullscreenchange", updateFullscreenDefault);
    fullscreenDocument.removeEventListener("webkitfullscreenchange", updateFullscreenWebkit);
    fullscreenDocument.removeEventListener("mozfullscreenchange", updateFullscreenMoz);
    fullscreenDocument.removeEventListener("msfullscreenchange", updateFullscreenMs);
    playbackElement.removeEventListener("loadedmetadata", updateFullscreeniOS);
    playbackElement.removeEventListener("webkitbeginfullscreen", updateEnterFullscreenWebkitiOS);
    playbackElement.removeEventListener("webkitendfullscreen", updateExitFullscreenWebkitiOS);
  };
  const setupiOSFullscreen = () => {
    if (canFullscreen) return;
    /**
     * If the media has already been loaded on the playbackElement (cases such as moving to persistent player mode),
     * call the updateFullscreeniOS function to add the iOS fullscreen event listeners. Otherwise, when the 'loadedmetadata'
     * event is called, the event listeners for iOS fullscreen will be added to the playbackElement.
     */
    if (playbackElement.readyState > 0) {
      updateFullscreeniOS();
    } else {
      playbackElement.addEventListener("loadedmetadata", updateFullscreeniOS);
    }
  };
  const fullscreenOn = () => {
    setFullScreen(true);
  };
  fullscreenOn.defaultReturn = undefined;
  const fullscreenOff = () => {
    setFullScreen(false);
  };
  fullscreenOff.defaultReturn = undefined;
  const getIsFullscreen = () => {
    return isFullscreen;
  };
  getIsFullscreen.defaultReturn = false;
  const element = containerNode;
  const fullscreenDocument = document;
  let isFullscreen = false;
  let playbackElement;
  let canFullscreen = fullscreenDocument.fullscreenEnabled || fullscreenDocument.mozFullScreenEnabled || fullscreenDocument.msFullscreenEnabled || fullscreenDocument.webkitFullscreenEnabled || false;
  let preFullScreenWidth = null;
  let preFullScreenHeight = null;
  let requestFullscreen = () => {
    var _a;
    (_a = element.requestFullscreen || element.mozRequestFullScreen || element.msRequestFullscreen || element.webkitRequestFullscreen) === null || _a === void 0 ? void 0 : _a.call(element);
  };
  let exitFullscreen = () => {
    var _a;
    (_a = fullscreenDocument.exitFullscreen || fullscreenDocument.mozCancelFullScreen || fullscreenDocument.msExitFullscreen || fullscreenDocument.webkitExitFullscreen) === null || _a === void 0 ? void 0 : _a.call(fullscreenDocument);
  };
  const adjustStylesForWebkit = restore => {
    if (restore) {
      if (preFullScreenWidth) element.style.setProperty("width", preFullScreenWidth);
      if (preFullScreenHeight) element.style.setProperty("height", preFullScreenHeight);
      preFullScreenWidth = null;
      preFullScreenHeight = null;
      return;
    }
    preFullScreenWidth = element.style.getPropertyValue("width");
    preFullScreenHeight = element.style.getPropertyValue("height");
    element.style.setProperty("width", "100%");
    element.style.setProperty("height", "100%");
  };
  init();
  return {
    destroy,
    isFullscreen: getIsFullscreen,
    fullscreenOn,
    fullscreenOff
  };
};
const TRACKED_EVENTS = {
  FOCUS: "focus",
  MOUSE_ENTER: "mouseenter",
  MOUSE_MOVE: "mousemove",
  MOUSE_LEAVE: "mouseleave",
  TOUCH_START: "touchstart",
  TOUCH_END: "touchend",
  KEY_DOWN: "keydown"
};
const UserInputEventsListener = (publicAPI, containerNode, callback) => {
  const _this = {
    tracking: false,
    userActivity: false,
    isUserActive: false,
    isPlaybackInProgress: false,
    playerStatus: "",
    activityCheckInterval: null,
    inactivityTimeout: null
  };
  const onObserverUpdate = state => {
    if (_this.playerStatus === state.status.to) return;
    _this.playerStatus = state.status.to;
    _this.isPlaybackInProgress = _this.playerStatus === STATUS.PLAYING || _this.playerStatus === STATUS.ADVERTISING;
    if (!_this.isPlaybackInProgress) _this.userActivity = true;
  };
  const onUserInteraction = payload => {
    if (payload.interactionOwner === "phoenix-player-main-node" && !_this.isUserActive) _this.userActivity = true;
  };
  const updateUserActive = active => {
    if (active === _this.isUserActive) return;
    _this.isUserActive = active;
    callback(active);
  };
  const onActivityEvent = event => {
    switch (event.type) {
      case TRACKED_EVENTS.MOUSE_LEAVE:
        if (_this.isPlaybackInProgress) {
          _this.userActivity = false;
          updateUserActive(false);
        }
        break;
      case TRACKED_EVENTS.TOUCH_START:
        if (!_this.isUserActive) {
          _this.userActivity = true;
          event.preventDefault();
        }
        break;
      case TRACKED_EVENTS.KEY_DOWN:
        {
          const {
            code
          } = event;
          if (Object.values(KEYBOARD_KEY_CODES).includes(code)) _this.userActivity = true;
          break;
        }
      case TRACKED_EVENTS.MOUSE_MOVE:
      case TRACKED_EVENTS.FOCUS:
      case TRACKED_EVENTS.TOUCH_END:
        _this.userActivity = true;
        break;
    }
  };
  const enableEventListeners = enabled => {
    const method = enabled ? "addEventListener" : "removeEventListener";
    containerNode[method](TRACKED_EVENTS.MOUSE_MOVE, onActivityEvent, {
      passive: true
    });
    containerNode[method](TRACKED_EVENTS.MOUSE_ENTER, onActivityEvent);
    containerNode[method](TRACKED_EVENTS.MOUSE_LEAVE, onActivityEvent);
    containerNode[method](TRACKED_EVENTS.TOUCH_START, onActivityEvent);
    containerNode[method](TRACKED_EVENTS.TOUCH_END, onActivityEvent);
    containerNode[method](TRACKED_EVENTS.FOCUS, onActivityEvent, true);
    containerNode[method](TRACKED_EVENTS.KEY_DOWN, onActivityEvent, true);
  };
  const start = () => {
    if (_this.tracking || !containerNode) return;
    _this.tracking = true;
    _this.isUserActive && callback(_this.isUserActive);
    enableEventListeners(true);
    publicAPI.mediaStateObserver.subscribe(onObserverUpdate);
    publicAPI.userInteractionsObserver.subscribe(onUserInteraction);
    _this.activityCheckInterval = setInterval(() => {
      if (_this.userActivity) {
        _this.userActivity = false;
        updateUserActive(true);
        clearTimeout(_this.inactivityTimeout);
        _this.inactivityTimeout = setTimeout(() => {
          if (!_this.userActivity && _this.isPlaybackInProgress) {
            updateUserActive(false);
          }
        }, HIDE_CONTROLS_TIMEOUT_DURATION);
      }
    }, 250);
  };
  const stop = () => {
    if (!_this.tracking) return;
    clearInterval(_this.activityCheckInterval);
    clearTimeout(_this.inactivityTimeout);
    publicAPI.mediaStateObserver.unsubscribe(onObserverUpdate);
    publicAPI.userInteractionsObserver.unsubscribe(onUserInteraction);
    enableEventListeners(false);
    callback(false);
    _this.userActivity = false;
    _this.tracking = false;
  };
  return {
    start,
    stop
  };
};
const indexCss = ".phoenix-player .phx-video-ui{display:block;width:100%;height:100%;position:absolute;top:0;left:0}";
const VideoUiStyle0 = indexCss;
const VideoUI = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isUserActive = true;
    this.sizeClass = "";
    this.hasResizeObserverSet = false;
    this.isFullscreenManagerInitialized = false;
    this.setIsUserActive = isActive => {
      this.isUserActive = isActive;
    };
    this.onObserverUpdate = state => {
      this.playerStatus = state.status.to;
    };
    this.initializeFullscreenManager = () => {
      var _a, _b;
      if (this.isFullscreenManagerInitialized) return;
      if (((_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.format) === "video" && this.playerStatus && this.playerStatus !== STATUS.READY) {
        this.fullscreenManager = FullscreenManager(this.containerNode);
        this.isFullscreenManagerInitialized = true;
      }
    };
  }
  connectedCallback() {
    var _a, _b, _c, _d;
    this.publicAPI.mediaStateObserver.subscribe(this.onObserverUpdate);
    if (((_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.format) === "video") {
      (_d = (_c = this.userInputEventsListener) === null || _c === void 0 ? void 0 : _c.start) === null || _d === void 0 ? void 0 : _d.call(_c);
    }
  }
  disconnectedCallback() {
    var _a;
    this.userInputEventsListener.stop();
    (_a = this.fullscreenManager) === null || _a === void 0 ? void 0 : _a.destroy();
    this.isFullscreenManagerInitialized = false;
  }
  componentDidRender() {
    this.initializeFullscreenManager();
  }
  componentDidLoad() {
    this.userInputEventsListener = UserInputEventsListener(this.publicAPI, this.containerNode, this.setIsUserActive);
    this.userInputEventsListener.start();
  }
  onFullscreenBtnClick(event) {
    var _a, _b, _c;
    event.stopPropagation();
    const isFullscreen = (_a = this.fullscreenManager) === null || _a === void 0 ? void 0 : _a.isFullscreen();
    isFullscreen ? (_b = this.fullscreenManager) === null || _b === void 0 ? void 0 : _b.fullscreenOff() : (_c = this.fullscreenManager) === null || _c === void 0 ? void 0 : _c.fullscreenOn();
    this.publicAPI.userInteractionsObserver.notifySubscribers({
      interactionOwner: "fullscreen-btn",
      interactionName: `${isFullscreen ? "exit" : "enter"}-fullscreen`,
      interactionType: "click"
    });
  }
  watchPropHandler() {
    var _a, _b, _c, _d;
    if (!((_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.format)) return;
    if (((_d = (_c = this.publicAPI) === null || _c === void 0 ? void 0 : _c.mediaData) === null || _d === void 0 ? void 0 : _d.format) === "video") {
      this.userInputEventsListener.start();
    } else {
      this.userInputEventsListener.stop();
    }
  }
  render() {
    var _a, _b;
    if (((_b = (_a = this.publicAPI) === null || _a === void 0 ? void 0 : _a.mediaData) === null || _b === void 0 ? void 0 : _b.format) !== "video") return null;
    return h("div", {
      class: `phx-video-ui ${this.isUserActive ? "" : "inactive"} ${this.sizeClass}`,
      "aria-label": "video player"
    }, h("info-overlay", {
      mediaData: this.publicAPI.mediaData
    }), h("indicator-overlay", {
      publicAPI: this.publicAPI
    }), h("control-rack", {
      publicAPI: this.publicAPI
    }), h("ready-overlay", {
      publicAPI: this.publicAPI
    }), h("loading-overlay", {
      playerStatus: this.playerStatus
    }), h("error-overlay", {
      publicAPI: this.publicAPI
    }), h("share-overlay", {
      publicAPI: this.publicAPI
    }), h("upcominglive-overlay", {
      publicAPI: this.publicAPI
    }), h("end-card-overlay", {
      publicAPI: this.publicAPI
    }));
  }
  static get watchers() {
    return {
      "publicAPI": ["watchPropHandler"]
    };
  }
};
VideoUI.style = VideoUiStyle0;
export { AdUIOverlay as ad_ui_overlay, AudioUI as audio_ui, VideoUI as video_ui };